import React from 'react';

import useIsMobile from '../hooks/useIsMobile';

const withDeviceType = BaseComponent => props => {
  const isMobile = useIsMobile(639);
  const isTablet = useIsMobile(1023);

  return (
    <BaseComponent
      {...props}
      isMobile={isMobile}
      isTablet={!isMobile && isTablet}
    />
  );
};

export default withDeviceType;
